export default "__VITE_ASSET__BpI2BSFv__"